<template lang="pug">
  app-modal(
    titulo="Sincronizar processo",
    @closeModal="cancelar",
    :width="500"
  )
    template(slot="body")
      el-row
        el-col
          app-label(
            label="Informe o número do recibo indicado no comprovante de envio do seu cadastro para o acompanhamento do processo.",
            :required="false"
          )
          validation-observer(ref='observer' tag='form')
            validation-provider(rules="required", v-slot="{ errors }", name="Protocolo" mode="lazy")
              app-label(label="Número do recibo:")
              el-input.input(
                name="Protocolo",
                v-mask="protocoloMask",
                v-model.trim="protocolo",
                :class="{'erro' : errors.length}"
                placeholder="XXXXXX-XXXXXXX-0000"
              )
              span.help.erro {{ errors[0] }}
    template(slot="footer")
      div.buttons
        el-button.cancelarButton(@click="cancelar")
          i.fas.fa-times
          span  &nbsp Cancelar
        el-button(
          type="primary",
          @click="vincularUsuarioProcesso"
        )
          i.fas.fa-check
          span &nbsp Confirmar

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from '@/utils/api'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppLabel from '@/components/AppLabel'
import AppModal from '@/components/AppModal'

export default {
  components: {
    AppLabel,
    AppModal
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      protocolo: '',
      protocoloMask: {
        mask: 'FFFFFF-FFFFFFF-FFFF',
        tokens: {
          F: {
            pattern: /[0-9a-zA-Z]/,
            transform: v => v.toLocaleUpperCase()
          }
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    })
  },

  methods: {
    ...mapActions({
      syncProtocolo: 'cadastro/syncProcesso'
    }),

    cancelar () {
      this.protocolo = ''
      this.$refs.observer.reset()
      this.$emit('cancelar')
    },

    carregaProcessos () {
      this.$emit('carregaProcessos')
    },

    async vincularUsuarioProcesso () {
      const result = await this.$refs.observer.validate()

      if (!result) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          'Informe um protocolo para sincronizar o processo.')
        return
      }

      try {
        const cpfCnpj = this.usuario.pessoa.pessoaFisica ? this.usuario.pessoa.pessoaFisica.cpf : this.usuario.pessoa.pessoaJuridica.cnpj

        await axios({ method: 'get', url: `processo/syncProtocolo?cpfCnpj=${cpfCnpj}&protocolo=${this.protocolo}` })

        this.carregaProcessos()
        this.cancelar()

        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
          'Processo sincronizado com sucesso!')
      } catch (error) {
        if (error !== '') {
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, error)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
  .el-alert {
    margin-bottom: 20px;
  }
  .buttons {
    display: flex;
    justify-content: space-between;
  }

  .cancelarButton:hover, .cancelarButton:focus {
    background-color:#fef0f0;
    color: #f56c6c;
    border-color: #fbc4c4;
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/processos/SincronizarProcesso.vue